<template>
    <rkm-modal
        :loading="loading"
        large
        ref="Modal"
        title="Lotes"
    >
        <rkm-form ref="Form">
            <rkm-table
                :fields="fields"
                :items="lotesAgrupados"
                hide-filters
            >
                <template v-slot:cell(fornecedor.nomeFantasia)="{ value }">
                    {{ value || '-' }}
                </template>

                <template v-slot:cell(lote)="{ value }">
                    {{ value || '-' }}
                </template>

                <template v-slot:cell(validadeLote)="{ value }">
                    {{ value || '-' }}
                </template>

                <template v-slot:cell(quantidadeSaida)="{ item }">
                    <rkm-form-input
                        :validations="getQuantidadeValidation(item)"
                        class="saida my-auto"
                        name="Saída"
                        type="number"
                        :value="item.quantidadeSaida"
                        @input="value => setQuantidadeSaidaGrupo(item, value)"
                    />
                </template>

                <template #afterTable>
                    <div class="mt-2">
                        <rkm-row>
                            <rkm-col class="text-right">
                                <h6 class="font-weight-bold mb-0">Quantidade de saídas: {{ quantidadeSaidas }}</h6>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </template>
            </rkm-table>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button
                :disabled="!!loading"
                @click="$refs.Modal.hide()"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                { key: 'fornecedor.nomeFantasia', label: 'Fornecedor' },
                { key: 'lote', label: 'Lote', class: 'col-min text-center' },
                { key: 'validadeLote', label: 'Validade', class: 'col-min text-center' },
                { key: 'estoque', label: 'Estoque', class: 'col-min text-center' },
                { key: 'quantidadeSaida', label: 'Saída', class: ' col-min text-center' },
            ]
        },
        quantidadeSaidas() {

            let quantidadeSaidas = 0

            this.items.forEach(item => {

                const quantidadeSaida = parseInt(item.quantidadeSaida)

                quantidadeSaidas += isNaN(quantidadeSaida) ? 0 : quantidadeSaida
            })

            return quantidadeSaidas
        },
        lotesAgrupados() {

            const grupos = []
            const grupoPorChave = {}

            this.items.forEach(item => {

                const chave = `${item.lote}|${item.validadeLote}`

                if (!grupoPorChave[chave]) {

                    grupoPorChave[chave] = {
                        lote: item.lote,
                        validadeLote: item.validadeLote,
                        fornecedor: item.fornecedor,
                        estoque: 0,
                        quantidadeSaida: 0,
                        itens: []
                    }

                    grupos.push(grupoPorChave[chave])
                }

                const grupo = grupoPorChave[chave]
                const estoque = parseInt(item.estoque)
                const quantidadeSaida = parseInt(item.quantidadeSaida)

                grupo.estoque += isNaN(estoque) ? 0 : estoque
                grupo.quantidadeSaida += isNaN(quantidadeSaida) ? 0 : quantidadeSaida

                if (!grupo.fornecedor?.nomeFantasia && item.fornecedor?.nomeFantasia) {

                    grupo.fornecedor = item.fornecedor
                }

                grupo.itens.push(item)
            })

            return grupos
        }
    },
    data: () => ({
        onSave: null,
        items: []
    }),
    methods: {
        open(entradaItens, onSave = null) {

            this.items = this.clone(entradaItens)
            this.onSave = onSave

            this.$refs.Modal.show()
        },
        save() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                const items = this.items.map(item => {

                    const quantidadeSaida = parseInt(item.quantidadeSaida)

                    item.quantidadeSaida = isNaN(quantidadeSaida) ? null : quantidadeSaida

                    return item
                })

                if (this.model) {

                    if (this.quantidadeSaidas != parseInt(this.model[this.quantidadeKey])) {

                        this.showValidationNotification(`A soma das saídas deve ser igual a quantidade total informada.
                            Quantidade total informada: ${this.model[this.quantidadeKey]}.`)

                        return;
                    }

                    this.model.entradaItens = this.clone(items)
                    this.model.escolheuEntradaItemManualmente = true
                }

                if (this.onSave !== null) {

                    this.onSave(items)
                }

                this.$refs.Modal.hide()
            })
        },
        getQuantidadeValidation(item) {

            return {
                min_value: 0,
                max_value: item.estoque
            }
        },
        setQuantidadeSaidaGrupo(grupo, value) {

            let quantidade = parseInt(value)

            quantidade = isNaN(quantidade) ? 0 : quantidade

            grupo.itens.forEach(item => {

                const estoque = parseInt(item.estoque) || 0

                if (quantidade <= 0) {

                    item.quantidadeSaida = 0

                    return
                }

                if (quantidade > estoque) {

                    item.quantidadeSaida = estoque
                    quantidade -= estoque
                }
                else {

                    item.quantidadeSaida = quantidade
                    quantidade = 0
                }
            })
        },
    },
    mixins: [ object ],
    props: {
        model: { type: Object, default: null },
        quantidadeKey: { type: String, default: 'quantidade' },
    }
}
</script>

<style scoped>
.saida {
    width: 220px;
}
</style>